import { render } from "./VerifyAuth.vue?vue&type=template&id=8b7e4552"
import script from "./VerifyAuth.vue?vue&type=script&lang=js"
export * from "./VerifyAuth.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__